import { createRouter, createWebHistory } from 'vue-router';
import routesPT from '../core/routes';
import LandingView from '../views/baz_landing/LandingView.vue';
import environmentConfig from '@/environment/environment.js';
import SessionDataService from '@/core/services/sessionDataService';

const SITIO_EN_MANTENIMIENTO = environmentConfig.environment.maintenanceMode;

const routes = [
  {
    path: '/',
    name: 'landing',
    component: LandingView,
  },
  {
    path: '/informacion/:cardId',
    name: 'cardDetail',
    component: LandingView,
  },
  // ── Pasos del formulario de tutores ──────────────────────────
  {
    path: routesPT.ROUTES.tutorDatos,
    name: 'tutorDatos',
    component: () => import('@/views/baz_statement-account/MainStatementAccountView.vue'),
    meta: { step: 1, requiresSession: false },
  },
  {
    path: routesPT.ROUTES.tutorOpciones,
    name: 'tutorOpciones',
    component: () => import('@/views/baz_statement-account/MainStatementAccountView.vue'),
    meta: { step: 2, requiresSession: true },
  },
  {
    path: routesPT.ROUTES.tutorExito,
    name: 'tutorExito',
    component: () => import('@/views/baz_statement-account/MainStatementAccountView.vue'),
    meta: { step: 3, requiresSession: true },
  },
  // ── Ruta legacy — redirige al primer paso ────────────────────
  {
    path: routesPT.ROUTES.tutorAccountStatement,
    redirect: routesPT.ROUTES.tutorDatos,
  },
  {
    path: '/mantenimiento',
    name: 'Mantenimiento',
    component: () => import('../core/components/MaintenanceWindowsView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('@/core/components/NotFoundView.vue'),
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

router.beforeEach((to, from, next) => {
  

  // ── Mantenimiento ────────────────────────────────────────────
  if (SITIO_EN_MANTENIMIENTO && to.name !== 'Mantenimiento') {
    next({ name: 'Mantenimiento' });
    return;
  }
  if (!SITIO_EN_MANTENIMIENTO && to.name === 'Mantenimiento') {
    next({ name: 'landing' });
    return;
  }

  // ── Proteger rutas que requieren sesión activa ───────────────
  // Si la ruta requiere sesión y no hay sesión, redirigir al landing
  if (to.meta.requiresSession && !SessionDataService.flagSessionActivate) {
    // Acceso denegado — sin sesión activa, redirigir al landing
    next({ name: 'landing' });
    return;
  }

  next();
});

router.afterEach(() => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);
});

export default router;